import { render } from "./Giveaway.vue?vue&type=template&id=2e2e8037&scoped=true&ts=true"
import script from "./Giveaway.vue?vue&type=script&lang=ts"
export * from "./Giveaway.vue?vue&type=script&lang=ts"

import "./Giveaway.vue?vue&type=style&index=0&id=2e2e8037&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2e8037"]])

export default __exports__